import React from 'react'
import { Platform, StyleSheet, View } from 'react-native'
import { ScrollView } from 'react-native-gesture-handler'

import { fontFamily } from '../../theme'
import { Text } from '../text/text'
import { CheatSheetTerminology } from './CheatSheetTerminology'
import PlayHands from './PlayHands'
import RankingCards from './RankingCards'
import { BottomSheetScrollView } from '@gorhom/bottom-sheet'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

const CheatSheetContent = () => {
  const insets = useSafeAreaInsets()

  return (
    <BottomSheetScrollView
      contentContainerStyle={{ paddingBottom: Platform.OS === 'web' ? 100 : 32 }}
      style={{ backgroundColor: '#F6F2E9' }}
    >
      <HandRankings />
    </BottomSheetScrollView>
  )
}

export const HandRankings = () => {
  return (
    <View style={styles.container}>
      <Text tx="cheatSheet.heading" style={[styles.title, { fontFamily: fontFamily.FeatureDeckMedium }]} />
      <PlayHands />
      <RankingCards />
      <CheatSheetTerminology />
    </View>
  )
}

export default CheatSheetContent

const styles = StyleSheet.create({
  rootContainer: {
    flex: 1
  },
  container: {
    flex: 1,
    backgroundColor: '#F6F2E9',
    paddingHorizontal: 32
  },
  title: {
    fontSize: 25,
    textAlign: 'center',
    color: '#121212'
  }
})
